export enum SetupParameterColumnType {
  SetupParameterType = 'SetupParameterType',
  InputType = 'InputType',
  Name = 'Name',
  Description = 'Description',
}
